import CardChartTotal from '@/components/ui/card-wrapper/CardChartTotal';
import MonthDropdown from '@/components/ui/date-picker/MonthDropdown';
import BarChartTotal from './BarChartTotal';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useGetUsageLogsDedicateInstance } from '@/service/one-click-deploy/hook';
import { useParams } from 'react-router-dom';
import { RouteParams } from '@/router/type';
import ButtonMonthPicker from '@/components/ui/date-picker/button-month-picker';
import { DataTable } from '@/components/ui/data-table/DataTable';
import { columns } from './columns';
import { Button } from '@/components/ui/button';
import { downloadCSV } from '@/utils/csv';
import { useGetDedicateInstanceById } from '../hook/useGetDedicateInstanceById';
import { fNumber } from '@/utils/formatNumber';

const OneClickDeployDetailActivity = () => {
  const { instanceId } = useParams<RouteParams>();
  const [date, setDate] = useState<Date>(new Date());

  const startMonth = dayjs(date).startOf('month').unix();
  const endMonth = dayjs(date).endOf('month').unix();

  const getDedicateInstanceById = useGetDedicateInstanceById();

  const { data } = useGetUsageLogsDedicateInstance({
    instance_id: instanceId!,
    time_unit: 'day',
    start_date: dayjs(date).startOf('month').toISOString(),
    end_date: dayjs(date).endOf('month').toISOString(),
  });

  const getUsageLogsDedicateInstanceByHour = useGetUsageLogsDedicateInstance({
    instance_id: instanceId!,
    time_unit: 'hour',
    start_date: dayjs(date).startOf('month').toISOString(),
    end_date: dayjs(date).endOf('month').toISOString(),
  });

  const dataTable = getUsageLogsDedicateInstanceByHour?.data?.content || [];
  
  const handleDownloadCSV = async () => {
    downloadCSV({
      data: dataTable,
      filename: `activity-${getDedicateInstanceById?.data?.instance_name}-${dayjs(date).format('YYYY-MM')}.csv`,
    });
  };

  return (
    <div>
      <div className="mt-4 flex flex-col gap-8">
        <div className="flex items-center justify-between">
          <ButtonMonthPicker
            value={date}
            onChange={setDate}
            className="min-w-[250px]"
            customLabelValue={`${dayjs(date).startOf('M').format('MMM D')} - ${dayjs(date).endOf('M').format('MMM D')} ${dayjs(date).format('YYYY')}`}
          />
          <Button variant={'secondary'} onClick={handleDownloadCSV}>
            Download CSV
          </Button>
        </div>
        <div className="grid gap-4 lg:grid-cols-2">
          <CardChartTotal
            title="Token"
            description="Total Token Usage"
            total={
              data?.content
                ?.reduce(
                  (acc, item) =>
                    acc + item.total_prompt_usage + item.total_completion_usage,
                  0
                )
                .toLocaleString() || 0
            }
          >
            <BarChartTotal
              chartData={
                data?.content?.map((item) => ({
                  date: dayjs(item.timestamp).unix(),
                  prompt: item.total_prompt_usage,
                  completion: item.total_completion_usage,
                })) || []
              }
              chartConfig={{
                prompt: {
                  color: 'hsl(var(--chart-1))',
                  label: 'Prompt Usage',
                },
                completion: {
                  color: 'hsl(var(--chart-2))',
                  label: 'Completion Usage',
                },
              }}
              startTime={startMonth}
              latestTime={endMonth}
              slots={{
                tooltipContent: {
                  labelFormatter: (_, payload) => {
                    return `${dayjs.unix(payload[0]?.payload.date).format('DD MMM')} | Total: ${fNumber(payload[0]?.payload.prompt + payload[0]?.payload.completion)}`;
                  },
                },
              }}
            />
          </CardChartTotal>
          <CardChartTotal
            title="Requests"
            description="Total Usage REST Requests"
            total={
              data?.content
                ?.reduce((acc, item) => acc + item.count, 0)
                .toLocaleString() || 0
            }
          >
            <BarChartTotal
              chartData={
                data?.content?.map((item) => ({
                  date: dayjs(item.timestamp).unix(),
                  count: item.count,
                })) || []
              }
              chartConfig={{
                count: {
                  color: 'hsl(var(--chart-1))',
                  label: 'Requests',
                },
              }}
              startTime={startMonth}
              latestTime={endMonth}
              slots={{
                tooltipContent: {
                  labelFormatter: (_, payload) => {
                    return `${dayjs.unix(payload[0]?.payload.date).format('DD MMM')}`;
                  },
                },
              }}
            />
          </CardChartTotal>
        </div>
        <DataTable columns={columns} data={dataTable} />
      </div>
    </div>
  );
};
export default OneClickDeployDetailActivity;
